// extracted by mini-css-extract-plugin
module.exports = {"snackBarWrapper":"MuiSnackbarItem_snackBarWrapper__STmuq","snackBarAlert":"MuiSnackbarItem_snackBarAlert__ZNKuH"};